import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import CrmPipelinesAPI from '../../../api/crm/pipelines';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getPipelines(_state) {
        return _state.records;
    },
    getPipelineById: _state => id => {
        return _state.records.find(p => p.id === Number(id));
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_CRM_PIPELINES_UI_FLAG, { isFetching: true });
        try {
            const response = await CrmPipelinesAPI.get();
            commit(types.SET_CRM_PIPELINES, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_CRM_PIPELINES_UI_FLAG, { isFetching: false });
        }
    },
    create: async ({ commit }, pipelineObj) => {
        commit(types.SET_CRM_PIPELINES_UI_FLAG, { isCreating: true });
        try {
            const response = await CrmPipelinesAPI.create(pipelineObj);
            commit(types.ADD_CRM_PIPELINE, response.data);
            return response.data;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_PIPELINES_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_CRM_PIPELINES_UI_FLAG, { isUpdating: true });
        try {
            const response = await CrmPipelinesAPI.update(id, updateObj);
            commit(types.EDIT_CRM_PIPELINE, response.data);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_PIPELINES_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_CRM_PIPELINES_UI_FLAG, { isDeleting: true });
        try {
            await CrmPipelinesAPI.delete(id);
            commit(types.DELETE_CRM_PIPELINE, id);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_PIPELINES_UI_FLAG, { isDeleting: false });
        }
    },
};

export const mutations = {
    [types.SET_CRM_PIPELINES_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [types.SET_CRM_PIPELINES]: MutationHelpers.set,
    [types.ADD_CRM_PIPELINE]: MutationHelpers.create,
    [types.EDIT_CRM_PIPELINE]: MutationHelpers.update,
    [types.DELETE_CRM_PIPELINE]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
